import React, {Component} from 'react';
import PropTypes from "prop-types";
import ModalDelete from "./components/ModalDelete";
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from "reactstrap";
import ModalCopy from "./components/ModalCopy";
import {FormattedMessage} from "react-intl";
import ModalAutoPagination from "./components/ModalAutoPagination";
import ModalRemovePageBreaks from "./components/ModalRemovePageBreaks";
import {connect} from "react-redux";
import {setPlanRestrictionsModals} from "reducers/planRestrictionsModals/actions";
import SetsAvailable from "components/PlanRestrictionsModals/modals/SetsAvailable";
import ClearContentInQuestions from "scenes/Survey/Structure/components/ClearContentInQuestions";

class HeaderActions extends Component {

  constructor(props) {
    super(props);

    this.state = {
      dropdownSettingsOpen: false,

      modalAutoPagination: false,
      modalRemovePageBreaks: false,
      modalCopy: false,
      modalDelete: false,
      modalClearContentInQuestion: false,
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle(type) {
    this.setState({
      [type]: !this.state[type]
    })
  }

  render() {
    const {set, optionsOpen, surveyPlan} = this.props;

    return (
      <div className="d-flex align-self-start py-0">
        <ul className="d-flex align-content-start ml-auto mb-0 p-0 pl-2">
          <li className="float-left">
            <Dropdown isOpen={this.state.dropdownSettingsOpen} toggle={() => this.toggle('dropdownSettingsOpen')}>
              <DropdownToggle className="m-0 p-0" color="">
                <span className="fas fa-ellipsis-v hoverable" />
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem tag="a" onClick={() => surveyPlan.sets ? this.props.handleToggleOptions() : this.props.setPlanRestrictionsModals(SetsAvailable.getName())} className={optionsOpen ? 'text-primary' : ''}>
                  <p><span className="fas fa-cog" style={optionsOpen ? {filter: 'none'} : {}}/></p> <FormattedMessage tagName="h5" id="set.headerActions.dropdownItem.settings"/>
                </DropdownItem>

                <DropdownItem tag="a" onClick={() => surveyPlan.sets ? this.toggle('modalAutoPagination') : this.props.setPlanRestrictionsModals(SetsAvailable.getName())}>
                  <p><span className="fas fa-bars"/></p> <FormattedMessage tagName="h5" id="set.headerActions.dropdownItem.autoPagination"/>
                </DropdownItem>

                <DropdownItem tag="a" onClick={() => this.toggle('modalClearContentInQuestion')}>
                  <p><span className="fa-solid fa-eraser" /></p> <h5>Usuń znaczniki w treści</h5>
                </DropdownItem>

                <DropdownItem tag="a" onClick={() => surveyPlan.sets ? this.toggle('modalRemovePageBreaks') : this.props.setPlanRestrictionsModals(SetsAvailable.getName())}>
                  <p><span className="fas fa-object-group"/></p> <FormattedMessage tagName="h5" id="set.headerActions.dropdownItem.removePageBreaks"/>
                </DropdownItem>

                <DropdownItem tag="a" onClick={() => surveyPlan.sets ? this.toggle('modalCopy') : this.props.setPlanRestrictionsModals(SetsAvailable.getName())}>
                  <p><span className="fas fa-copy"/></p> <FormattedMessage tagName="h5" id="set.headerActions.dropdownItem.copy"/>
                </DropdownItem>

                <DropdownItem tag="a" onClick={() => this.toggle('modalDelete')}>
                  <p><span className="fas fa-trash"/></p> <FormattedMessage tagName="h5" id="set.headerActions.dropdownItem.delete"/>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
            {this.state.modalAutoPagination && <ModalAutoPagination set={set} isOpen={this.state.modalAutoPagination} toggleModal={() => this.toggle('modalAutoPagination')}/>}
            {this.state.modalRemovePageBreaks && <ModalRemovePageBreaks set={set} isOpen={this.state.modalRemovePageBreaks} toggleModal={() => this.toggle('modalRemovePageBreaks')}/>}
            {this.state.modalCopy && <ModalCopy set={set} isOpen={this.state.modalCopy} toggleModal={() => this.toggle('modalCopy')}/>}
            {this.state.modalDelete && <ModalDelete set={set} isOpen={this.state.modalDelete} toggleModal={() => this.toggle('modalDelete')}/>}
            {this.state.modalClearContentInQuestion && <ClearContentInQuestions setBlocksId={set.id} toggleModal={() => this.toggle('modalClearContentInQuestion')}/>}
          </li>
        </ul>
      </div>
    )
  }
}

HeaderActions.propTypes = {
  set: PropTypes.object.isRequired,
  handleToggleOptions: PropTypes.func.isRequired,
  optionsOpen: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    surveyPlan: state.user.userPlan.plan.survey,
  }
}

export default connect(mapStateToProps, {setPlanRestrictionsModals})(HeaderActions);
